import React, { FC, useMemo } from 'react';
import { PatientImportResultDto } from '@docbay/schemas';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AttentionIcon } from 'applicaiton/assets/attention.svg';

import { usePatientErrorValidation } from 'features/feature-my-patients/hooks/usePatientErrorValidation';

import { FieldNames, Languages } from './models';
import {
  PatientInfo,
  PatientList,
  Wrapper,
  WrapperItem,
  ErrorsList,
} from './styles';

interface Props {
  data: PatientImportResultDto[];
}

const ErrorPatients: FC<Props> = ({ data }) => {
  const { t, i18n } = useTranslation();
  const { patientErrorsList } = usePatientErrorValidation();

  const currentLanguage = useMemo(() => {
    return (localStorage.getItem('i18nextLng')?.slice(0, 2).toUpperCase() ||
      'PT') as Languages;
  }, [i18n.language]);

  return (
    <Wrapper>
      <p>
        {data.length} {t('patient.contacts_imported_with_error')}
      </p>
      <PatientList>
        {data.map((item, index) => {
          return (
            <WrapperItem
              key={`error_${item.patient.socialSecurityNumber}`}
              className={'error'}
            >
              <div>
                <AttentionIcon />
                <PatientInfo>
                  <p>
                    {index + 1}. {item.patient.firstName}{' '}
                    {item.patient.lastName}
                  </p>
                  <span>{item?.patient?.phone || ''}</span>
                  <ErrorsList>
                    {item?.errors?.map((error, ind) => {
                      return (
                        <span key={ind}>
                          {(error.fieldNames as FieldNames)[currentLanguage]}{' '}
                          {patientErrorsList[error.errorCode]}
                        </span>
                      );
                    })}
                  </ErrorsList>
                </PatientInfo>
              </div>
              <div>{t('patient.tab_error')}</div>
            </WrapperItem>
          );
        })}
      </PatientList>
    </Wrapper>
  );
};

export default ErrorPatients;
